import { useLocation, Navigate } from 'react-router-dom';
import React from 'react';
import { Auth } from '../../helpers/Auth';

export const RequireAuth = ({ children }: { children: React.JSX.Element }) => {
  const location = useLocation();

  if (!Auth.isSignedIn()) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
};
